/* eslint-disable eqeqeq */
import {
  Box,
  Flex,
  Text,
  Menu,
  MenuButton,
  Button,
  MenuList,
  MenuItem,
  Tooltip,
  // Divider,
  // useToast,
} from '@chakra-ui/react';
import { useSelector, useDispatch } from 'react-redux';
// import { GoChevronDown } from 'react-icons/go';
import { useEffect, useMemo, useState } from 'react';

// import CustomToast from 'components/CustomToast';
import Plus from 'components/Icons/Plus';
import RemoveIconComponent from 'components/Icons/RemoveIcon';
import { AppDispatch } from 'utils/GlobalHelpers';
import DimensionIconComponent from 'components/Icons/DimensionIcon';
import {
  getDashboardBlocks,
  createInstrument,
  updateInstrument,
  setEditInstrumentOutput,
  getSelectedDashboardScenario,
  getCompareDashboardScenario,
  setEditInstrumentData,
} from 'redux/DashboardSliceV2';

import useInstrumentDates from './hooks/useInstrumentDates';

interface Properties {
  widget?: any;
  isEditKpi?: any;
}

export function findDimensionItems(instrumentData: any, blockDetails: any) {
  // Check if instrumentData and instrument_indicators array exist
  if (!instrumentData || !Array.isArray(instrumentData?.instrument_indicators)) {
    return [];
  }

  // Use a Map to store unique dimensionId entries
  const uniqueDimensions = new Map();

  instrumentData.instrument_indicators.forEach((indicator: any) => {
    if (
      indicator?.formatting &&
      Array.isArray(indicator?.formatting?.dimensionItems) &&
      indicator?.formatting?.dimensionItems.length > 0 &&
      indicator?.dimension_id && // Add to the map only if the dimensionId is not already present
      !uniqueDimensions.has(indicator.dimension_id)
    ) {
      const foundBlock = blockDetails.find((block: any) => block.block_id === indicator.block_id);
      const foundIndicator = foundBlock?.indicators?.find(
        (ind: any) => ind.indicator_id == indicator.indicator_id,
      );
      const foundDimension = foundIndicator?.indicator_dimensions?.find(
        (dim: any) => dim.indicator_dimension_id == indicator.dimension_id,
      );
      uniqueDimensions.set(indicator.dimension_id, {
        dimensionId: indicator.dimension_id,
        dimensionName: foundDimension?.indicator_dimension_name || indicator?.dimension_name,
        dimensionItems: indicator.formatting.dimensionItems.map((dItem: any) => ({
          dimensionItemId: dItem?.dimension_item_id,
          dimensionItemName: dItem?.dimension_item_name,
        })),
      });
    }
  });

  // Return unique dimension items as an array
  return Array.from(uniqueDimensions.values());
}

const DashboardModalFilters = ({ widget }: Properties) => {
  const dispatch: AppDispatch = useDispatch();
  const selectedDashboardScenario = useSelector(getSelectedDashboardScenario);
  const compareDashboardScenario = useSelector(getCompareDashboardScenario);
  const blockDetails = useSelector(getDashboardBlocks);
  const { buildPreviewPayload } = useInstrumentDates();
  const [selectedDimFilter, setSelectedDimFilter] = useState<any[]>([]);
  const [dimensions, setDimensions] = useState<any>([]);
  const processedDimensionsData = useMemo(() => {
    const returnValue = widget
      ? widget?.instrument_indicators
          ?.filter((indicator: any) => indicator?.dimension_id && indicator?.indicator_id)
          .map(({ block_id, indicator_id }: any) => {
            const foundBlock = blockDetails.find((block: any) => block.block_id === block_id);
            const foundIndicator = foundBlock?.indicators?.find(
              (indicator: any) => indicator.id === indicator_id,
            );
            return {
              blockid: block_id,
              indicatorid: indicator_id,
              dimension: foundIndicator?.indicator_dimensions || [],
            };
          })
      : [];

    return returnValue;
  }, [widget?.instrument_indicators, blockDetails]);

  useEffect(() => {
    if (!processedDimensionsData?.length) {
      setDimensions([]);
      return;
    }

    const firstIndicatorDimensions = processedDimensionsData[0].dimension;

    if (processedDimensionsData.length === 1) {
      setDimensions([firstIndicatorDimensions]);
      return;
    }

    const commonDimensions = firstIndicatorDimensions.filter((firstDim: any) => {
      return processedDimensionsData.every((indicator: any) => {
        return indicator.dimension.some(
          (dim: any) => dim.indicator_dimension_id === firstDim.indicator_dimension_id,
        );
      });
    });

    const hasInstrumentIndicators = widget?.instrument_indicators?.length > 0;
    const hasDimensionId = widget?.instrument_indicators[0]?.dimension_id;

    if (!hasInstrumentIndicators) {
      setDimensions([]);
      return;
    }

    if (hasDimensionId) {
      const neededArray = commonDimensions.filter(
        (dim: any) =>
          dim.indicator_dimension_id === Number(widget?.instrument_indicators[0]?.dimension_id),
      );
      setDimensions([neededArray]);
      return;
    }

    setDimensions([]);
  }, [processedDimensionsData, widget?.instrument_indicators]);

  const matchedFilters = useMemo(() => {
    const responseWithFilter = findDimensionItems(widget, blockDetails);
    setSelectedDimFilter(responseWithFilter);
    return responseWithFilter;
  }, [widget?.id, widget?.instrument_indicators, blockDetails]);

  const handleAddingFilter = () => {
    setSelectedDimFilter([
      ...selectedDimFilter,
      {
        dimensionId: 0,
        dimensionItems: [],
        dimensionName: 'Dimension',
      },
    ]);
  };
  const getRandomColor = () => `#${Math.floor(Math.random() * 16_777_215).toString(16)}`;
  const handleRemovingFilter = (data: any) => {
    const updatedFilters = selectedDimFilter.filter(
      (dim: any) => dim.dimensionId !== data.dimensionId,
    );
    const insturmentIndicators = JSON.parse(JSON.stringify(widget?.instrument_indicators));
    const instrumentIndicatorsWIthDimensionItems = insturmentIndicators.map((instrument: any) => {
      if (instrument.dimension_id === data?.dimensionId) {
        instrument.formatting = { color: getRandomColor() };
        // const matchingData = data.find((dim: any) => dim.dimensionId);
        // if (matchingData) {
        //   instrument.dimension_id = null;
        //   instrument.formatting = {
        //     color: getRandomColor(),
        //   };
        // }
      }
      return instrument;
    });
    const sharedOverrides = {
      instrument_indicators: instrumentIndicatorsWIthDimensionItems,
      scenario_id: selectedDashboardScenario?.id ? `${selectedDashboardScenario?.id}` : '',
      compare_scenario: compareDashboardScenario?.id || null,
    };

    if (!widget.id) {
      dispatch(
        createInstrument({
          request_body: buildPreviewPayload(widget, sharedOverrides),
        }),
      ).then((result) => {
        dispatch(setEditInstrumentOutput(result?.payload?.data));
        dispatch(
          setEditInstrumentData({
            ...widget,
            instrument_indicators: result?.payload?.instrument_indicators,
          }),
        );
      });
    } else {
      // Dimension-filter removal persists to the DB (save: true) in addition to refreshing data.
      dispatch(
        updateInstrument({
          request_body: buildPreviewPayload(widget, { ...sharedOverrides, save: true }),
        }),
      ).then((result) => {
        dispatch(setEditInstrumentOutput(result?.payload?.data));
        dispatch(
          setEditInstrumentData({
            ...widget,
            instrument_indicators: result?.payload?.instrument_indicators,
          }),
        );
      });
    }
    setSelectedDimFilter(updatedFilters);
  };
  // Function to generate a random hex color
  const handleDimensionSelect = (data: any) => {
    const updatedFilters = selectedDimFilter
      .filter((f) => f.dimensionId !== 0) // Remove items with dimensionId 0
      .concat(
        data.map((dim: any) => ({
          dimensionId: dim.indicator_dimension_id,
          dimensionName: dim.indicator_dimension_name,
          dimensionItems: dim.indicator_dimension_items.map((item: any) => ({
            dimensionItemId: item.indicator_dimension_item_id,
            dimensionItemName: item.indicator_dimension_item_name,
          })),
        })),
      );
    const insturmentIndicators = JSON.parse(JSON.stringify(widget?.instrument_indicators));
    const instrumentIndicatorsWIthDimensionItems = insturmentIndicators.map((instrument: any) => {
      if (instrument.dimension_id === data[0]?.indicator_dimension_id) {
        const matchingData = data.find((dim: any) => dim.indicator_dimension_id);
        if (matchingData) {
          instrument.dimension_id = data[0]?.indicator_dimension_id;
          instrument.formatting = {
            dimensionItems: matchingData.indicator_dimension_items.map((item: any) => ({
              dimension_item_id: item.indicator_dimension_item_id,
              dimension_item_name: item.indicator_dimension_item_name,
              color: getRandomColor(),
            })),
          };
        }
      }
      return instrument;
    });
    const sharedOverrides = {
      instrument_indicators: instrumentIndicatorsWIthDimensionItems,
      scenario_id: selectedDashboardScenario?.id ? `${selectedDashboardScenario?.id}` : '',
      compare_scenario: compareDashboardScenario?.id || null,
    };

    if (!widget.id) {
      dispatch(
        createInstrument({
          request_body: buildPreviewPayload(widget, sharedOverrides),
        }),
      ).then((result) => {
        dispatch(setEditInstrumentOutput(result?.payload?.data));
        dispatch(
          setEditInstrumentData({
            ...widget,
            instrument_indicators: result?.payload?.instrument_indicators,
          }),
        );
      });
    } else {
      // Dimension selection persists to the DB (save: true) in addition to refreshing data.
      dispatch(
        updateInstrument({
          request_body: buildPreviewPayload(widget, { ...sharedOverrides, save: true }),
        }),
      ).then((result) => {
        dispatch(setEditInstrumentOutput(result?.payload?.data));
        dispatch(
          setEditInstrumentData({
            ...widget,
            instrument_indicators: result?.payload?.instrument_indicators,
          }),
        );
      });
    }
    setSelectedDimFilter(updatedFilters);
  };

  const { label, isDisabled } = useMemo(() => {
    const indicators = widget?.instrument_indicators?.filter((ind: any) => ind?.indicator_id) || [];
    const dimMap = new Set<string>();
    let allDimsSelected = true;

    indicators.forEach((ind: any) => {
      if (ind?.dimension_id) {
        dimMap.add(ind.dimension_id);
      } else {
        allDimsSelected = false;
      }
    });

    let returnLabel = 'Filters are only available if all indicators share common dimensions';
    let returnDisabled = true;

    if (indicators.length === 0) {
      returnLabel = 'Please select indicators to add filters';
    } else if (!allDimsSelected) {
      returnLabel = 'Filters are only available if all indicators share common dimensions';
    } else if (dimMap.size === 0) {
      returnLabel = 'Please select dimension';
    } else if (dimMap.size === 1) {
      returnLabel = 'Add Filter';
      returnDisabled = false;
    }

    if (returnDisabled) {
      setSelectedDimFilter([]);
    }

    return { label: returnLabel, isDisabled: returnDisabled };
  }, [widget?.instrument_indicators]);

  if (!matchedFilters) {
    return <></>;
  }

  return (
    <Flex flexDir={'column'}>
      <Flex alignItems={'center'} justifyContent={'space-between'}>
        <Text color={'black.800'} fontWeight={'600'}>
          Filters
        </Text>
        <Tooltip label={label} aria-label='Add filter tooltip' placement='top' hasArrow>
          <Button width={'14.583px'} disabled={isDisabled || selectedDimFilter?.length > 0}>
            <Plus color='#787878' onClick={handleAddingFilter} />
          </Button>
        </Tooltip>
      </Flex>
      {/* <Flex
        cursor={'pointer'}
        onClick={handleAddingFilter}
        justifyContent={'space-between'}
        alignItems={'center'}
        backgroundColor={'#FAFAFA'}
        border={'1px #D9D9D9 solid'}
        padding={'.5rem .8rem'}
        borderRadius={'6px'}
        color={'black.600'}
        fontSize={'2xs'}
      >
        <Text>{'Click to add filter'}</Text>
      </Flex> */}
      <>
        <Box>
          <Flex mb={1}>
            <Text size={'Roboto-14'} color={'#B5B5B5'} width={'50%'}>
              Dimension
            </Text>
            <Text size={'Roboto-14'} color={'#B5B5B5'} width={'50%'}>
              Default filter
            </Text>
          </Flex>
          <Flex flexDir={'column'} gap={4}>
            {selectedDimFilter.map((item: any) => {
              return (
                <Flex
                  alignItems={'center'}
                  justifyContent={'space-between'}
                  gap={2}
                  // key={item.localId}
                >
                  <Flex
                    backgroundColor={'#FAFAFA'}
                    flex={1}
                    borderRadius={'6px'}
                    alignItems={'center'}
                    border={'1px solid'}
                    justifyContent={'space-between'}
                    borderColor={'grey.700'}
                  >
                    <Tooltip placement='top' label={item.dimensionName}>
                      <Box width={'50%'}>
                        <Menu variant={'dashboardingModal'}>
                          {() => (
                            <>
                              <MenuButton
                                as={Button}
                                padding={'.3rem .5rem'}
                                variant={'dashboardingModal'}
                                border={'none'}
                                color={'#212121'}
                                fontWeight={'600'}
                                width={'100%'}
                              >
                                <Flex alignItems={'center'} justifyContent={'space-between'}>
                                  <Flex gap={1.5} alignItems={'center'}>
                                    <DimensionIconComponent
                                      height={5}
                                      width={5}
                                      color={'#4BB6B9'}
                                    />
                                    {item.dimensionName?.length > 10 ? (
                                      <Text>{item.dimensionName.slice(0, 10)}...</Text>
                                    ) : (
                                      <Text>{item.dimensionName || 'Dimension'}</Text>
                                    )}
                                  </Flex>
                                </Flex>
                              </MenuButton>
                              <MenuList>
                                <>
                                  {dimensions &&
                                    dimensions[0]?.map((dimension: any) => {
                                      return (
                                        <MenuItem
                                          onClick={() => handleDimensionSelect([dimension])}
                                          key={dimension.indicator_dimension_id}
                                        >
                                          {dimension.indicator_dimension_name}
                                        </MenuItem>
                                      );
                                    })}
                                </>
                              </MenuList>
                            </>
                          )}
                        </Menu>
                      </Box>
                    </Tooltip>
                  </Flex>
                  <RemoveIconComponent
                    color={'black.900'}
                    onClick={() => handleRemovingFilter(item)}
                  />
                </Flex>
              );
            })}
          </Flex>
        </Box>
      </>
    </Flex>
  );
};

export default DashboardModalFilters;
